import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCardActions = {
  styleOverrides: {
    root: { padding: "0 24px 32px 24px", justifyContent: "right" },
  },
} satisfies Components<Theme>["MuiCardActions"];
